import { render, staticRenderFns } from "./AddFoodRecipes.vue?vue&type=template&id=4d4fc9e4&"
import script from "./AddFoodRecipes.vue?vue&type=script&lang=js&"
export * from "./AddFoodRecipes.vue?vue&type=script&lang=js&"
import style0 from "./AddFoodRecipes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports